import React, { useState, useEffect, useContext } from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {FormControlLabel, FormGroup, Switch} from "@material-ui/core";

import Box from '@material-ui/core/Box';
import ReactLoading from 'react-loading';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

import getDisplayLayersList from "../functions/getAdditionalDisplayLayers";

import ProductLayer from './LayerProductCard';


const FindSwitch = withStyles({
  switchBase: {
    color: '#0C4C35',
    '&$checked': {
      color: '#0C4C35',
    },
    '&$checked + $track': {
      backgroundColor: '#0C4C35',
    },
    '&.Mui-disabled': {
      color: '#ccc',
    },
  },
  checked: {},
  track: {},
})(Switch);


export default function LayerPanel(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      width: props.width,
      minWidth: props.width,
      height: props.height - 30,
      overflowY: "auto",
      background: "#fff",
    },
    panelHeader:{
      background: '#0C4C35',
      height: 48
    },
    panelLabel:{
      margin: '15px 25px',
      marginBottom:15,
      color:'#fff'
    },
    queryControlBox: {
      padding: '10px 15px 10px 20px',
      background: '',
    },
    queryControlLabel: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: 5,
      marginRight: 5,
      color: '#000',

        '& .MuiTypography-root': {
          fontSize: 13
        }
    }
  }));

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [uState] = useContext(UserContext);

  const [layerProducts, setLayerProducts] = useState([]);
  const [doInfo, setDoInfo] = useState(sState.doInfoQuery);
  const [doInfoDisabled, setDoInfoDisabled] = useState(sState.doInfoDisabled);


  useEffect(() => {
      getDisplayLayersList(sState, uState.company.companytype, sDispatch);
  },[]);

  useEffect(() => {
    if (sState.dlayerList.length >= 1){
      setLayerProducts(sState.dlayerList);
    }
  },[sState.dlayerList]);

  useEffect(() => {
    let setAction ='';
    if (sState.doInfoQuery === true && sState.doInfoDisabled !== true){
      setAction ='doInfoQuery';
    } else {
      setAction ='endInfoQuery';
    }

    sDispatch({ type: "setUserAction", payload: { action: setAction } });
  },[sState.doInfoQuery]);

  useEffect(() => {
    setDoInfoDisabled(sState.doInfoDisabled);
  },[sState.doInfoDisabled]);

  useEffect(() => {
    // Temporarily disable query tool when annotation tools are used
    if (sState.caction === 'displaytools') {
      setDoInfoDisabled(true);
      sDispatch({ type: "setDoInfoDisabled", payload: { doInfoDisabled: true } });

      if (doInfo) {
        sDispatch({ type: "setDoInfoQuery", payload: { doInfoQuery: false } });
      }
    }

    // Re-enable query tool after using annotation tools
    if (sState.caction === 'endtools') {
      setDoInfoDisabled(false);
      sDispatch({ type: "setDoInfoDisabled", payload: { doInfoDisabled: false } });

      if (doInfo) {
        sDispatch({ type: "setDoInfoQuery", payload: { doInfoQuery: true } });
      }
    }
  },[sState.caction]);

  const handleDoInfo = () => {
    // Toggle doInfo
    // NOTE: using local variable to ensure consistency - setDoInfo seems to work asynchronously
    let newDoInfo = !doInfo;
    setDoInfo(newDoInfo);

    sDispatch({ type: "setDoInfoQuery", payload: { doInfoQuery: newDoInfo } });
  }

  const handleProductSelect = (productid, selected) => {

  }


  return (
    <div className={classes.root}>
        <Box display="flex" className={classes.panelHeader}>
          <Box flexGrow={1} display="flex"><Box className={classes.panelLabel} fontSize={15} >Available layers</Box></Box>
        </Box>
        <Box >
          {layerProducts.map((item, i) =>
                <ProductLayer key={i} productcode={item.productcode} item={item} handleSelect={handleProductSelect} tooltip={'Add layer'} />
          )}
        </Box>
        <Box>
          <FormGroup className={classes.queryControlBox}>
            <FormControlLabel
                control={<FindSwitch checked={doInfo} onChange={handleDoInfo} />}
                label="Query map data"
                labelPlacement="start"
                className={classes.queryControlLabel}
                disabled={doInfoDisabled}
            />
          </FormGroup>
        </Box>
    </div>
  );
}